module.exports = __webpack_public_path__ + "img/baizhi-back-two.afa84393.png";